module.exports = __webpack_public_path__ + "static/WEDDING E&M-338-b19ef0573c58c2cc285521be21217d5d.jpg";